import React from 'react'
import {Navbar, Footer, Currencies} from './Components'

const App = () => {
  return (
    <div>
        <Navbar />
        <Currencies />
        <Footer />

    </div>
  )
}

export default App